// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.custom-textbox[data-v-5638b6fa] {\r\n    background: white;\r\n    border-radius: 5px;\r\n    border: 1px solid #03142533;\r\n    color: black;\n}\n.custom-textbox[data-v-5638b6fa]:hover {\r\n    background: white;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
